import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  refundContainer: {
    padding: theme.spacing(3),
    width: "fit-content",
    margin: "0 auto",
  },
  title: {
    marginBottom: theme.spacing(4),
    fontWeight: 400,
    textAlign: "left",
    paddingRight: theme.spacing(4),
  },
  value: {
    marginBottom: theme.spacing(3)
  },
  submitButton: {
    minWidth: 200,
    marginTop: theme.spacing(3),
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
  }
}));